<template>
    <el-col :span="14" class="search-wrapper">
        <div class="grid-content">
            <el-row style="width: 100%">
                <el-col :span="24">
                    <el-popover
                        placement="top"
                        popper-class="grid-search-dialog"
                        trigger="manual"
                        v-model="isSearchVisible"
                        v-on-clickaway="hideSearch"
                        width="1150"
                    >
                        <el-input
                            slot="reference"
                            v-model="searchString"
                            @clear="this.hideSearch"
                            placeholder="Поиск"
                            class="el-autocomplete-search search-wrap"
                            suffix-icon="bitch"
                            @keyup.native="findString"
                            clearable
                        >
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <template>
                            <div class="grid-content" v-loading="loadingSearch">
                                <template v-for="(item, key) in result">
                                    <el-row :key="key">
                                        <el-col :span="2">
                                            <div class="mt5">
                                                <h2 class="entityTitle">
                                                    {{ searchBlockName(key) }}
                                                </h2>
                                            </div>
                                        </el-col>
                                        <el-col :span="22">
                                            <template v-for="(searchResult, searchIndex) in item.items">
                                                <div @click="goEntity(key, searchResult)" :key="searchIndex" class="search-item">
                                                    <div class="search-item-text" v-html="searchResult.value"></div>
                                                </div>
                                            </template>
                                            <div v-if="item.items.length < item.info.value">
                                                <div @click="goEntityList(key)" class="search-item search-item-orange">
                                                    Показать все ({{ item.info.value }})
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </template>
                            </div>
                        </template>
                    </el-popover>
                </el-col>
            </el-row>
        </div>
    </el-col>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { eventBus } from '@/common/eventBus';

export default {
    name: 'Search',
    mixins: [
        clickaway
    ],
    data: function() {
        return {
            searchString: null,
            onlyMine: false,
            isSearchVisible: false,
            isFilterFormVisible: false,
            loadingSearch: false,
            result: null
        };
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        currentRoute() {
            return this.$route.path;
        },
        fullPath() {
            return this.$route.query.search;
        }
    },
    methods: {
        searchBlockName(key) {
            switch (key) {
                case 'lead':
                    return 'Лид';
                case 'deal':
                    return 'Сделка';
                case 'contact':
                    return 'Контакт';
            }
            return '';
        },
        goEntity(key, searchResult) {
            let routeName = '';

            this.$router.replace(this.currentRoute + '?search=' + this.searchString);
            switch (key) {
                case 'deal':
                    routeName = 'deal-card';
                    break;
                case 'lead':
                    routeName = 'lead-card';
                    break;
                case 'contact':
                    routeName = 'contact-card';
                    break;
            }
            this.searchString = null;
            this.isSearchVisible = false;
            this.$router.push({ name: routeName, params: { id: '' + searchResult.id } });
        },
        goEntityList(key) {
            this.$router.replace(this.currentRoute + '?search=' + this.searchString);
            const routeName = 'search-' + key + '-list';
            const queryString = this.searchString.replace(/[^0-9A-zА-я.@/-]?/g, '');
            const route = { name: routeName, params: { query: queryString } };
            this.isSearchVisible = false;
            this.$router.push(route);
        },
        hideSearch() {
            this.isSearchVisible = false;
        },
        findString() {
            this.isSearchVisible = true;
            this.loadingSearch = true;
            const queryString = this.searchString.replace(/[^0-9A-zА-я.@/-]?/g, '');
            this.$store.dispatch('search/find', { query: queryString }).then(
                response => {
                    this.result = response.data.data;
                }
            ).finally(() => {
                this.loadingSearch = false;
            });
        }
    },
    watch: {
        fullPath(value) {
            if (value) {
                if (!this.isSearchVisible) {
                    this.searchString = value;
                    return this.findString(value);
                }
            } else {
                this.hideSearch();
            }
        }
    }
};
</script>
